export const INTEGRATIONS_BASE_URL = '/control-panel/integrations';
export const INTEGRATIONS_DIRECTORY_PATH = `${INTEGRATIONS_BASE_URL}/directory`;
export const INTEGRATIONS_CONNECTED_PATH = `${INTEGRATIONS_BASE_URL}/connected`;
export const INTEGRATIONS_MARKETING_PATH = `${INTEGRATIONS_BASE_URL}/marketing`;

export enum IntegrationType {
  BLOOM_INTELLIGENCE = 'BLOOM_INTELLIGENCE',
  COMMERCE7 = 'COMMERCE7',
  THE_CUSTOMER_CONNECTION = 'THE_CUSTOMER_CONNECTION',
  TRIPLESEAT_LEADS = 'TRIPLESEAT_LEADS',
  TOAST = 'TOAST',
  UNTILL = 'UNTILL',
  LIGHTSPEED = 'LIGHTSPEED',
  WINEDIRECT_CLASSIC = 'WINEDIRECT_CLASSIC',
  GOOGLE_ANALYTICS_WEB_PROPERTY = 'GOOGLE_ANALYTICS_WEB_PROPERTY',
  GOOGLE_ANALYTICS_WEB_PROPERTY_4 = 'GOOGLE_ANALYTICS_WEB_PROPERTY_4',
  MICROS = 'MICROS',
  ACTIV8 = 'ACTIV8',
  ORDERPORT = 'ORDERPORT',
  MICROS_3700 = 'MICROS_3700',
  POSITOUCH = 'POSITOUCH',
  ALOHA = 'ALOHA',
  REDCHIRP = 'REDCHIRP',
  TRIPLESEAT_EVENTS = 'TRIPLESEAT_EVENTS',
  SQUARE_POS = 'SQUARE_POS',
  ECELLAR = 'ECELLAR',
}

export enum IntegrationStatus {
  PENDING_INTEGRATION = 'PENDING_INTEGRATION',
  ACTIVE_INTEGRATION = 'ACTIVE_INTEGRATION',
}
